import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=49b103f0&scoped=true&"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayout.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./DefaultLayout.vue?vue&type=style&index=1&id=49b103f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b103f0",
  null
  
)

export default component.exports